/* eslint-disable */

import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Space,
  Typography,
  Modal,
  Form,
  Input,
  message,
  Popconfirm,
  Card,
} from 'antd';
import {
  UserSwitchOutlined,
  PlusOutlined,
  ReloadOutlined,
  EditOutlined,
  DeleteOutlined,
  UserOutlined,
  LockOutlined,
} from '@ant-design/icons';
import axios from 'axios';

const { Title, Text } = Typography;

function AccountOffice(props) {
  const [form] = Form.useForm();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [usermode, setUsermode] = useState('');
  const [useritem, setUseritem] = useState({});

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    api_getUserList();
  }, []);

  async function api_getUserList() {
    setLoading(true);

    const formData = new FormData();
    axios
      .post(props.app_hostname + '/api/account/office/getlist', formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.status === 'OK') {
          setUsers(response.data.users);
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาดในการโหลดข้อมูล');
        }
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  function handleAdd() {
    setUsermode('add');
    setUseritem({});
    form.resetFields();
    setIsModalOpen(true);
  }

  function handleEdit(record) {
    setUsermode('edit');
    setUseritem(record);
    form.setFieldsValue({
      username: record.username,
      password: record.password,
      confirmpassword: record.password,
      firstname: record.firstname,
      lastname: record.lastname,
    });
    setIsModalOpen(true);
  }

  async function handleSubmit(values) {
    if (usermode === 'add' && values.username.toUpperCase() === 'ADMIN') {
      form.setFields([
        {
          name: 'username',
          errors: ['ชื่อผู้ใช้ต้องไม่เป็น ADMIN'],
        },
      ]);
      return;
    }

    if (values.password !== values.confirmpassword) {
      form.setFields([
        {
          name: 'confirmpassword',
          errors: ['รหัสผ่านไม่ตรงกัน'],
        },
      ]);
      return;
    }

    setModalLoading(true);

    const formData = new FormData();
    formData.append('username', values.username);
    formData.append('password', values.password);
    formData.append('confirmpassword', values.confirmpassword);
    formData.append('firstname', values.firstname);
    formData.append('lastname', values.lastname);

    if (usermode === 'edit') {
      formData.append('id', useritem.id);
    }

    axios
      .post(props.app_hostname + '/api/account/office/' + usermode, formData, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setModalLoading(false);
        if (response.data.status === 'OK') {
          setUsers(response.data.users);
          setIsModalOpen(false);
          message.success('บันทึกข้อมูลสำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาด');
        }
      })
      .catch((err) => {
        setModalLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  async function handleDelete(record) {
    setLoading(true);

    const postdata = {
      id: record.id,
    };
    axios
      .post(props.app_hostname + '/api/account/office/delete', postdata, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + props.permitdata.token,
        },
      })
      .then((response) => {
        setLoading(false);
        if (response.data.status === 'OK') {
          setUsers(response.data.users);
          message.success('ลบข้อมูลสำเร็จ');
        } else {
          message.error(response.data.message || 'เกิดข้อผิดพลาด');
        }
      })
      .catch((err) => {
        setLoading(false);
        message.error(err.message || 'เชื่อมต่อเซิร์ฟเวอร์ล้มเหลว');
      });
  }

  const columns = [
    {
      title: '#',
      key: 'index',
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: 'ชื่อผู้ใช้',
      dataIndex: 'username',
      key: 'username',
      sorter: (a, b) => a.username?.localeCompare(b.username),
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: 'ชื่อจริง',
      dataIndex: 'firstname',
      key: 'firstname',
      sorter: (a, b) => a.firstname?.localeCompare(b.firstname),
    },
    {
      title: 'นามสกุล',
      dataIndex: 'lastname',
      key: 'lastname',
      sorter: (a, b) => a.lastname?.localeCompare(b.lastname),
    },
    {
      title: 'จัดการ',
      key: 'action',
      width: 150,
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            type='primary'
            icon={<EditOutlined />}
            size='small'
            onClick={() => handleEdit(record)}
          >
            แก้ไข
          </Button>
          <Popconfirm
            title='ยืนยันการลบ'
            description='คุณแน่ใจหรือไม่ที่จะลบผู้ใช้นี้?'
            onConfirm={() => handleDelete(record)}
            okText='ตกลง'
            cancelText='ยกเลิก'
          >
            <Button type='primary' danger icon={<DeleteOutlined />} size='small'>
              ลบ
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className='page-wrapper'>
      <div className='page-card'>
        <Space direction='vertical' size='large' style={{ width: '100%' }}>
          <div className='page-header-actions'>
            <div>
              <Title level={3} style={{ margin: 0 }}>
                <UserSwitchOutlined style={{ color: '#1890ff', marginRight: '8px' }} />
                บัญชีเจ้าหน้าที่
              </Title>
              <Text type='secondary'>เครื่องมือจัดการบัญชีเจ้าหน้าที่</Text>
            </div>
            <Space>
              <Button icon={<PlusOutlined />} type='primary' onClick={handleAdd}>
                เพิ่มใหม่
              </Button>
              <Button icon={<ReloadOutlined />} onClick={api_getUserList} loading={loading}>
                รีเฟรช
              </Button>
            </Space>
          </div>

          <div>
            <Title level={5} style={{ marginBottom: '16px' }}>
              รายการบัญชีเจ้าหน้าที่ <span>({users.length} บัญชี)</span>
            </Title>

            {/* Desktop Table View */}
            <div className='accountshop-desktop-view'>
              <Table
                columns={columns}
                dataSource={users}
                rowKey='id'
                loading={loading}
                pagination={{ pageSize: 10, showTotal: (total) => `ทั้งหมด ${total} บัญชี` }}
                size='small'
                scroll={{ x: true }}
              />
            </div>

            {/* Mobile Card View */}
            <div className='accountshop-mobile-view'>
              <div
                style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '4px 0' }}
              >
                {users.map((item) => (
                  <Card
                    key={item.id}
                    size='small'
                    style={{ borderRadius: '12px', border: '1px solid #e2e8f0' }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                      }}
                    >
                      <div>
                        <Text strong style={{ fontSize: '15px', color: '#1e293b' }}>
                          {item.firstname} {item.lastname}
                        </Text>
                        <br />
                        <Text type='secondary' style={{ fontSize: '13px' }}>
                          Username: {item.username}
                        </Text>
                      </div>
                      <Space>
                        <Button
                          type='primary'
                          icon={<EditOutlined />}
                          size='small'
                          onClick={() => handleEdit(item)}
                        >
                          แก้ไข
                        </Button>
                        <Popconfirm
                          title='ยืนยันการลบ'
                          description='คุณแน่ใจหรือไม่ที่จะลบผู้ใช้นี้?'
                          onConfirm={() => handleDelete(item)}
                          okText='ตกลง'
                          cancelText='ยกเลิก'
                        >
                          <Button type='primary' danger icon={<DeleteOutlined />} size='small'>
                            ลบ
                          </Button>
                        </Popconfirm>
                      </Space>
                    </div>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        </Space>
      </div>

      <Modal
        title={
          <Space>
            <UserSwitchOutlined />
            {usermode === 'add' ? 'เพิ่มบัญชีเจ้าหน้าที่' : 'แก้ไขบัญชีเจ้าหน้าที่'}
          </Space>
        }
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={600}
        centered
      >
        <Form form={form} layout='vertical' onFinish={handleSubmit} style={{ marginTop: '24px' }}>
          <Form.Item
            name='username'
            label='ชื่อผู้ใช้ / รหัสพนักงาน'
            rules={[
              { required: true, message: 'กรุณากรอก Username' },
              { min: 5, message: 'อย่างน้อย 5 ตัวอักษร' },
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder='Username'
              disabled={usermode === 'edit'}
            />
          </Form.Item>

          <Space style={{ width: '100%' }} size='middle'>
            <Form.Item
              name='password'
              label='รหัสผ่าน'
              rules={[
                { required: true, message: 'กรุณากรอก Password' },
                { min: 8, message: 'อย่างน้อย 8 ตัวอักษร' },
                {
                  pattern: /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/,
                  message: 'ต้องมีตัวพิมพ์ใหญ่, ตัวพิมพ์เล็ก และตัวเลข',
                },
              ]}
              style={{ width: '100%' }}
            >
              <Input.Password prefix={<LockOutlined />} placeholder='Password' />
            </Form.Item>

            <Form.Item
              name='confirmpassword'
              label='ยืนยันรหัสผ่าน'
              dependencies={['password']}
              rules={[{ required: true, message: 'กรุณายืนยัน Password' }]}
              style={{ width: '100%' }}
            >
              <Input.Password prefix={<LockOutlined />} placeholder='Confirm Password' />
            </Form.Item>
          </Space>

          <Space style={{ width: '100%' }} size='middle'>
            <Form.Item
              name='firstname'
              label='ชื่อจริง'
              rules={[
                { required: true, message: 'กรุณากรอกชื่อจริง' },
                { min: 2, message: 'อย่างน้อย 2 ตัวอักษร' },
              ]}
              style={{ width: '100%' }}
            >
              <Input placeholder='Firstname' />
            </Form.Item>

            <Form.Item
              name='lastname'
              label='นามสกุล'
              rules={[
                { required: true, message: 'กรุณากรอกนามสกุล' },
                { min: 2, message: 'อย่างน้อย 2 ตัวอักษร' },
              ]}
              style={{ width: '100%' }}
            >
              <Input placeholder='Lastname' />
            </Form.Item>
          </Space>

          <div
            style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}
          >
            <Button onClick={() => setIsModalOpen(false)}>ยกเลิก</Button>
            <Button type='primary' htmlType='submit' loading={modalLoading}>
              บันทึก
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
}

export default AccountOffice;
